import { Box, Button, HStack, Text } from "@chakra-ui/react";
import React from "react";

export interface PromptButtonProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  [key: string]: unknown;
}

const PromptButton: React.FC<PromptButtonProps> = (props) => {
  const { icon, title, description, ...rest } = props;
  return (
    <Button
      variant="ghost"
      flexDirection="column"
      alignItems="stretch"
      bg="gray.50"
      borderWidth="1px"
      borderColor="gray.200"
      rounded="md"
      px={4}
      py={3}
      fontSize="sm"
      height="auto"
      _hover={{ bg: "purple.50", borderColor: "purple.200" }}
      _active={{ bg: "purple.100", borderColor: "purple.300" }}
      {...rest}
    >
      <HStack spacing={2} align="center" mb={description ? 1 : 0}>
        <Box color="purple.600">{icon}</Box>
        <Text textAlign="start" fontWeight="medium" m={0}>
          {title}
        </Text>
      </HStack>
      {description && (
        <Text textAlign="start" color="fg.muted" fontSize="xs" noOfLines={2} m={0} whiteSpace="normal">
          {description}
        </Text>
      )}
    </Button>
  );
};

export default PromptButton;